<div class="flex flex-row">
<div *ngIf="initialized && length && numberOfPages >= 1" class="flex flex-row justify-center items-center mat-subtitle-2 mb-0 fw-500 mr-12 paginator-dropdown pt-4 pr-4 pb-4 pl-12">
  {{ 'PAGINATOR.ITEMS_PER_PAGE' | transloco }}
  <div class="paginator-form-field ml-12">
    <select [(ngModel)]="pageSize" (change)="pageSizeChanged()">
      <option *ngFor="let pageSizeOption of pageSizeOptions" [ngValue]="pageSizeOption">{{ pageSizeOption }}</option>
    </select>
  </div>
</div>
<div *ngIf="initialized && length && numberOfPages >= 1" class="flex flex-row justify-between items-center h-32 paginator pt-4 pr-4 pb-4 pl-12 user-select-none">
  <div class="flex flex-row justify-center items-center">
    <div class="fs-16 fw-600 mat-subtitle-2 mb-0">{{pageIndex * pageSize + 1}} - {{(pageIndex * pageSize + pageSize) > length ? length : (pageIndex * pageSize + pageSize)}} of {{length}}</div>
    <mat-icon svgIcon="chevron_left" class="icon-lg" [ngClass]="{'disabled' : pageIndex === 0}" (click)="pageIndex !== 0 && goToPage(pageIndex - 1)"></mat-icon>
    

    <mat-icon svgIcon="chevron_right" class="icon-lg" [ngClass]="{'disabled' : pageIndex === numberOfPages - 1}"
      (click)="pageIndex !== numberOfPages - 1 && goToPage(pageIndex + 1)"></mat-icon>
  </div>
  </div>
</div>

